import { Outlet } from '@tanstack/react-router'
import { Navbar } from './Navbar'
import { Footer } from './Footer'
import { Notifications } from '@/components/ui/Notifications'
import { AIFab } from '@/components/common/AIFab'
import type { JSX, ReactNode } from 'react'

interface PublicLayoutProps {
  children?: ReactNode
}

export function PublicLayout({ children }: PublicLayoutProps): JSX.Element {
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-1">
        {children ?? <Outlet />}
      </main>
      <Footer />
      <Notifications />
      <AIFab />
    </div>
  )
}